import { useMemo } from "react";
import DeskSelect from "@/components/common/DeskSelect";
import { COUNTRIES } from "@/lib/countries";

export const normCountry = (s) => String(s ?? "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
const BY_NORM = new Map(COUNTRIES.map((c) => [normCountry(c.name), c]));
const BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c]));
/** Reconnaît une valeur texte existante (nom FR sans accents/majuscules, ou code alpha-2) — jamais réécrite. */
export const findCountry = (v) => (v ? BY_NORM.get(normCountry(v)) || BY_CODE.get(String(v).toUpperCase()) || null : null);
export const isAlgeria = (v) => !v || findCountry(v)?.code === "DZ";

/** 29.3 — drapeau SVG local (paquet flag-icons copié dans public/flags par scripts/sync-flags.mjs), 20×15, radius 2 ; aucun emoji, aucun chargement réseau. */
export function Flag({ code, size = 20 }) {
  if (!code) return null;
  return <img src={`${process.env.PUBLIC_URL || ""}/flags/4x3/${code.toLowerCase()}.svg`} alt="" width={size} height={Math.round(size * 3 / 4)} draggable={false} style={{ width: size, height: Math.round(size * 3 / 4), borderRadius: 2, objectFit: "cover", display: "inline-block", flexShrink: 0 }} data-testid={`flag-${code.toLowerCase()}`} />;
}

/** 29.6 — valeur affichée : drapeau + nom si reconnue, sinon le texte tel quel. */
export function CountryLabel({ value, size = 16, style, testId }) {
  const c = findCountry(value);
  if (!value) return <span style={{ color: "#4A4A52", ...style }}>—</span>;
  return <span className="inline-flex items-center" style={{ gap: 6, ...style }} data-testid={testId}>{c && <Flag code={c.code} size={size} />}<span>{c ? c.name : value}</span></span>;
}

/** iter468 29.2 — CountryPicker : même rendu que LocationPicker (DeskSelect searchable) ; la valeur reste le NOM français (compatible avec les données existantes). */
export default function CountryPicker({ value, onChange, disabled = false, width = 320, testId = "country", placeholder = "Choisir un pays…", triggerStyle }) {
  const options = useMemo(() => {
    const base = COUNTRIES.map((c) => ({ value: c.name, label: c.name, search: c.code, icon: <Flag code={c.code} /> }));
    const known = findCountry(value);
    return value && !known ? [{ value, label: value, search: "", icon: null }, ...base] : base;  // texte non reconnu : affiché tel quel, sans drapeau
  }, [value]);
  const known = findCountry(value);
  return <DeskSelect searchable width={width} disabled={disabled} value={known ? known.name : value || ""} options={options} onChange={(v) => onChange(v)} placeholder={placeholder} testId={testId} triggerStyle={triggerStyle} />;
}
